import React from 'react';
import { ArrowRight, Download } from 'lucide-react';
import { motion } from 'framer-motion';
import { Reveal } from './Reveal';

export const CTASection = () => {
  const handleDownloadBrochure = () => {
    // Open the PDF in a new tab
    window.open('https://customer-assets-7cd3h4nn.emergentagent.net/job_f4be8578-e0f8-41cb-9e1f-bf96d9cd7952/artifacts/gvonu13d_Arogya%20Vitalis%20Brochure.pdf', '_blank');
  };

  return (
    <section
      className="section-padding relative overflow-hidden"
      style={{ background: 'linear-gradient(135deg, #6A3F8F 0%, #5A3580 100%)' }}>

      {/* Decorative depth blobs */}
      <div className="blob-bg blob-purple animate-float-slow" style={{ width: '360px', height: '360px', top: '-120px', left: '8%', opacity: 0.16 }}></div>
      <div className="blob-bg blob-clay animate-float-slow" style={{ width: '320px', height: '320px', bottom: '-120px', right: '6%', opacity: 0.12 }}></div>

      <div className="container-custom relative z-10">
        <Reveal className="max-w-4xl mx-auto text-center">
          <h2 className="hero-medium mb-8" style={{ color: '#FDFBF9' }}>
            Ready to transform your health?
          </h2>
          <p className="body-large mb-12" style={{ color: 'rgba(255, 255, 255, 0.9)' }}>
            Book your 1:1 consultation and take the first step toward feeling lighter in your body, calmer in your mind, and happier in your everyday life.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <motion.a
              href="https://wa.me/919766144233?text=Hi, I would like to book a consultation with Tanmayee"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid="cta-book-consultation-btn"
              whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: 'spring', stiffness: 400, damping: 12 }}>

              Book Your Consultation
              <ArrowRight size={20} />
            </motion.a>
            <button
              onClick={handleDownloadBrochure}
              className="btn-secondary"
              data-testid="cta-download-brochure-btn"
              style={{
                background: 'transparent',
                color: 'white',
                borderColor: 'white'
              }}>

              <Download size={20} />
              Download Brochure
            </button>
          </div>
        </Reveal>
      </div>
    </section>);

};